<template>
  <div class="page-template rule-page" v-loading="loading">
    <!--        <menu-list></menu-list>-->
    <el-button type="primary" @click="add">添加</el-button>
    <search-form-template :searchOptions="searchOptions"
                          @searchSubmit="getRuleList" @clear="getRuleList"></search-form-template>
    <el-dialog title="新增商品规格名称"
               custom-class="rule-dialog"
               :visible.sync="addShow"
               width="500px">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="规格名称" prop="ruleName">
          <el-input class="name-ipt" placeholder="商品规格名称" :maxlength="16" v-model="form.ruleName"></el-input>
        </el-form-item>
      </el-form>
      <div style="text-align: center">
        <el-button type="primary" @click="ruleSubmit">提交</el-button>
      </div>
    </el-dialog>


    <div class="specs-list" v-if="ruleList.length>0">
      <div class="rule-box" v-for="rule in ruleList" :key="rule.id">
        <div class="rule-title">{{rule.name}}</div>
        <div class="item-list">
          <div class="rule-item add-box">
            <el-input placeholder="新增" v-model="rule.newSpecs" :maxlength="16">
              <el-button class="specs-add" slot="append" @click="specsSubmit(rule.newSpecs,rule.id)">保存</el-button>
            </el-input>
          </div>
          <div class="specs-list-content">
            <div class="rule-item" v-for="specs in rule.children" :key="specs.id">{{specs.name}}
              <i @click="deleteRule(rule, specs)" class="el-icon-close rule-icon"></i>
            </div>
          </div>
        </div>
        <div class="btn-box">
          <el-button @click="deleteRule(rule)">删除</el-button>
        </div>
      </div>
    </div>
    <div v-else style="text-align: center;color:#d8d8d8">暂无数据</div>
  </div>
</template>
<script>
  import api from '@/config/api'
  import searchFormTemplate from '@/components/template/searchFormTemplate'
  import userPower from '@/mixin/userPower'

  export default {
    mixins: [userPower],
    components: {searchFormTemplate},
    data() {
      return {
        searchOptions: {simple: [{prop: 'name', label: '', labelWidth: 0, isFuzzy: true, placeholder: '请输入商品规格名称'}]},
        loading: false,
        title: '',
        ruleList: [],
        addShow: false,
        form: {
          ruleName: ''
        },
        rules: {
          ruleName: [{required: true, message: '请输入商品规格名称', trigger: 'blur'}]
        },
      }
    },
    mounted() {
      this.title = document.title;
      this.getRuleList();
    },
    methods: {
      handleChange() {
      },
      //打开新增界面
      add() {
        this.form.ruleName = ''
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
        this.addShow = true
      },
      specsSubmit(ruleName, parentId) {
        if (ruleName) {
          this.addRule(ruleName, parentId);
        } else {
          this.$message.warning('新增不能为空')
        }
      },
      // 提交
      ruleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.addRule(this.form.ruleName, 0);
          } else {
            return false
          }
        })
      },
      addRule(name, parentId) {
        this.$loading({text: '提交中，请稍后。。。'})
        this.$axios.fetchPost(api.archives.goodsSpecs, {name, parentId})
          .then(data => {
            if (data.code == 200) {
              this.getRuleList();
              this.$notify({
                type: "success",
                title: '添加操作',
                message: '成功',
                showClose: false,
              });
            } else {
              this.$message({message: data.errorMsg || "请求失败！", type: "error"});
            }
            this.addShow = false
          }).catch(err => {
          this.$message({message: "请求失败！", type: "error"});
        }).finally(() => {
          this.$loading({}).close()
        })
      },
      // 刷新列表
      getRuleList(param) {
        this.$axios.fetchPost(api.archives.goodsSpecs + '/list', param)
          .then(data => {
            this.loading = false;
            if (data.code == 200 && data.data) {
              let ruleList = this.$utils.dealCascadeData(data.data);
              ruleList.map(item => {
                item.newSpecs = '';
              });
              this.ruleList = ruleList;
            } else {
              this.$message({message: data.errorMsg || "请求失败！", type: "error"});
            }
          }).catch(err => {
          this.$message({message: "请求失败！", type: "error"});
          this.loading = false;
        });
      },

      deleteRule(rule, specs) {
        this.$confirm(`是否确认删除${specs ? ('规格[' + rule.name + ']的子属性' + `{${specs.name}}`) : ('名称为{' + rule.name + '}的规格')}?`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.loading = true;
          this.$axios.fetchDelete(api.archives.goodsSpecs, {id: specs ? specs.id : rule.id})
            .then(data => {
              this.loading = false;
              if (data.code == 200) {
                this.getRuleList();
                this.$notify({
                  type: "success",
                  title: '删除操作',
                  message: '成功',
                  showClose: false,
                });
              } else {
                if (data.code === 11010144) {
                  this.$message.warning(data.errorMsg);
                } else {
                  this.$message({message: data.errorMsg, type: "error"});
                }
              }
            }).catch(err => {
            this.$message({message: err.errorMsg || '请求失败', type: "error"});
            this.loading = false;
          });
        });
      }
    }
  }
</script>
<style>
  .rule-page .name-ipt {
    margin-right: 10px;
  }

  .rule-page .specs-list .rule-box {
    border: 1px solid #d8d8d8;
    margin-bottom: 16px;
    border-radius: 5px;
  }

  .rule-page .specs-list .rule-box:hover {
    border: 1px solid #5e57e3;
  }

  .rule-page .specs-list .rule-box:hover .rule-title {
    background-color: #5e57e3;
    color: #fff;
  }

  .rule-page .specs-list .rule-box .rule-title {
    height: 45px;
    line-height: 45px;
    background-color: #f0f0f0;
    padding: 0 20px;
    border-radius: 5px 5px 0 0;
  }

  .rule-page .specs-list .rule-box .item-list {
    display: flex;
    padding: 15px;
  }

  .rule-page .specs-list .rule-box .btn-box {
    height: 40px;
  }

  .rule-page .el-input.el-input-group {
    border: 0;
  }

  .rule-page .rule-item {
    height: 30px;
    line-height: 28px;
    min-width: 150px;
    text-align: center;
    margin-right: 15px;
    border: 1px solid #ccc;
    padding-right: 30px;
    margin-bottom: 10px;
    position: relative;
  }

  .rule-page .rule-item.add-box {
    border: 0;
    width: 200px;
  }

  .rule-page .specs-list .rule-box:hover .el-input-group > .el-input__inner {
    border-color: #458cff;
  }

  .rule-page .specs-list .rule-box:hover .el-input-group__append, .el-input-group__prepend {
    border-color: #458cff;
    background-color: #458cff;
  }

  .rule-page .el-input.el-input-group .el-input__inner {
    border-right: 0;
    height: 100%;
  }

  /*.rule-page .el-input-group__append button.el-button.specs-add{*/
  /*  color:#fff;*/
  /*}*/
  /*.rule-page .specs-list .rule-box:hover button.el-button.specs-add{*/
  /*  color:#fff;*/
  /*}*/
  .rule-page .rule-item .rule-icon {
    width: 30px;
    height: 30px;
    line-height: 28px;
    text-align: center;
    position: absolute;
    right: 0;
    top: 0;
    border-left: 1px solid #ccc;
    cursor: pointer;
  }

  .rule-page .rule-dialog {
    min-width: unset;
  }

  .rule-page .el-input, .el-input-number {
    height: 30px !important;
  }

  .specs-list-content {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
  }
</style>



// WEBPACK FOOTER //
// src/page/archives/goods/Rule.vue